import { type KnackFieldType } from '@/types/schema/KnackField';

export const FORM_GROUP_ID_PREFIX = 'group_';
export const FORM_COLUMN_ID_PREFIX = 'column_';
export const FORM_DIVIDER_INPUT_ID_PREFIX = 'divider_';
export const FORM_SECTION_BREAK_INPUT_ID_PREFIX = 'section_break_';

export const DISALLOWED_FIELD_TYPES_IN_FORMS: KnackFieldType[] = [
  'concatenation',
  'auto_increment',
  'sum',
  'min',
  'max',
  'average',
  'count'
];
